var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"live-title"},[_vm._v("Live")]),_c('div',{staticClass:"bck-txt"},[_c('marquee',{attrs:{"behavior":"","direction":""}},[_vm._v(_vm._s(_vm.event.title))])],1),_c(_vm.selectedComponent,_vm._b({tag:"component"},'component',_vm.event,false)),_c('div',{staticClass:"vt"},[_vm._v(_vm._s(_vm.event.live_event_text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }